export const FETCH_FE_PERFORMANCE_REQUEST = 'FETCH_FE_PERFORMANCE_REQUEST';
export const FETCH_FE_PERFORMANCE_SUCCESS = 'FETCH_FE_PERFORMANCE_SUCCESS';
export const FETCH_FE_PERFORMANCE_FAILURE = 'FETCH_FE_PERFORMANCE_FAILURE';
